<mat-toolbar color="primary" class="fd-accreditation-navbar no-print">
  <div *ngIf="!isCEF" class="fd-accreditation-navbar__left-arrow" (click)="triggerBackAction()">
    <fa-icon icon="arrow-left"></fa-icon>
  </div>
  <h1 class="fd-accreditation-navbar__title">{{ getButtonLabel() }}</h1>
  <div class="fd-accreditation-navbar__user-wrapper">
    <div class="fd-accreditation-navbar__subchannel-dropdown-container" *ngIf="hasHierarchyDropdown && hasMoreThanOneHierarchy">
      <fd-select
        class="fd-accreditation-navbar__subchannel-dropdown"
        (loadItemsFn)="listSubChannels($event, fields.subChannel)"
        [parentForm]="formGroup"
        [field]="fields.subChannel"
        (selectionChange)="setSelectedSubChannel()"
        (selectClosed)="selectSubChannelClose()"
      >
      </fd-select>
    </div>
    <div
      class="fd-accreditation-navbar__subchannel-dropdown-container"
      *ngIf="hasHierarchyDropdown && hasMoreThanOneHierarchy && hasMoreThanOneAgentIdBySubChannel"
    >
      <fd-select
        class="fd-accreditation-navbar__subchannel-dropdown"
        [parentForm]="formGroup"
        [field]="fields.agentChannel"
        (selectionChange)="setSelectedAgentChannel()"
      >
      </fd-select>
    </div>
    <button mat-button [matMenuTriggerFor]="menu" class="fd-accreditation-navbar__user">
      <span class="fd-accreditation-navbar__user-content">
        <span class="fd-accreditation-navbar__user-name">Olá, {{ name }}</span>
        <fa-icon icon="user-circle" class="user-circle"></fa-icon>
        <fa-icon icon="sort-down" class="user-down"></fa-icon>
      </span>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()"><fa-icon icon="sign-out-alt" class="sign-out-alt"></fa-icon> Sair</button>
    </mat-menu>
  </div>
</mat-toolbar>
